import script from "./vehicle_item.vue?vue&type=script&setup=true&lang=js"
export * from "./vehicle_item.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__